<template>
  <div class="deviceStatistic">
    <device-param class="section" :deviceInfo="deviceInfo"></device-param>
    <div class="section flow">
      <!-- <div class="title">{{$t('device.energyFlow')}}</div> -->
      <div class="scene">
        <div class="generation-container" @click="activeDialog='pv_'">
          <div class="image">
            <img v-if="flowData.generation.status" :src="imgPath.generation" />
            <img v-else src="@/assets/img/generation_disable.png" />
          </div>
          <span class="name">{{$t('device.generation')}}</span>
        </div>
        <div class="grid-container" @click="activeDialog='gd_'">
          <div class="image">
            <img v-if="flowData.grid.status" :src="imgPath.grid" />
            <img v-else src="@/assets/img/grid_disable.png" />
          </div>
          <span class="name">{{$t('device.grid')}}</span>
        </div>
        <div class="inverter-container" @click="activeDialog='sy_'">
          <div class="image">
            <img
              style="height:130px;width:130px"
              v-if="flowData.inverter.status!==1"
              :src="imgPath.inverter"
            />
            <img
              style="height:130px;width:130px"
              v-else
              src="@/assets/img/inverter_disable.png"
            />
          </div>
          <span class="name">{{$t('device.brandDevice')}}</span>
          <!-- <span class="name">{{flowData.inverter.label}}</span> -->
        </div>
        <!-- 单独拿出判断所用图片 -->
        <div class="battery-container" @click="activeDialog='bt_'">
          <div class="image">
            <img v-if="flowData.battery.status" :src="batteryPath.battery" />
            <img v-else :src="batteryPath.batterys" />
            <!-- <img v-else src="@/assets/img/battery_disable.png" /> -->
          </div>
          <span class="name">{{$t('device.battery')}}</span>
        </div>
        <div class="consumption-container" @click="activeDialog='bc_'">
          <div class="image">
            <img v-if="flowData.consumption.status" :src="imgPath.consumption" />
            <img v-else src="@/assets/img/consumption_disable.png" />
          </div>
          <span class="name">{{$t('device.consumption')}}</span>
        </div>
        <!-- 光伏板 -->
        <div
          class="value-generation"
          :class="{enable: flowData.generation.status===1, negative: flowData.generation.status===1}"
        >
          <!-- <div class="value-generation" :class="{enable: flowData.generation.status,negative: flowData.generation.status===1}"> -->
          <div class="data">{{flowData.generation.val}}</div>
        </div>
        <!-- 电网 -->
        <div
          class="value-grid"
          :class="{enable: flowData.grid.status===1||flowData.grid.status===-1, positive: flowData.grid.status===1, negative: flowData.grid.status===-1}"
        >
          <div class="data">{{flowData.grid.val}}</div>
        </div>
        <!-- 电池 -->
        <div
          class="value-battery"
          :class="{enable:flowData.battery.status===-1||flowData.battery.status===1, positive: flowData.battery.status===-1, negative: flowData.battery.status===1}"
        >
          <div class="data">
            <div>{{flowData.battery.val[0]}}</div>
            <div v-if="flowData.battery.val[1]">{{flowData.battery.val[1]}}</div>
          </div>
        </div>
        <!-- 负载 -->
        <div
          class="value-consumption"
          :class="{enable:flowData.consumption.status===-1, negative: flowData.consumption.status===-1}"
        >
          <div class="data">{{flowData.consumption.val}}</div>
        </div>
      </div>
    </div>
    <device-dialog
      :visible.sync="activeDialog"
      :title="activeDialogInfo.title"
      v-if="activeDialog"
      :width="'auto'"
      noFooter
      class="dialog"
    >
      <div class="list" slot="content">
        <template v-for="item in activeDialogInfo.data">
          <span :key="item.id+item.unit" class="item">
            {{item.par}}
            <span v-if="item.unit">({{item.unit}})</span>
          </span>
          <span :key="item.id+item.val" class="item">{{item.val}}</span>
        </template>
      </div>
    </device-dialog>
  </div>
</template>
<script>
import { mapGetters,mapState } from 'vuex';
import deviceDialog from "@/components/dialog";
import deviceParam from "@/components/param";
export default {
  components: {
    deviceDialog,
    deviceParam
  },
  data() {
    return {
      timerEnergy: "",
      flowData: {
        generation: {
          status: 0,
          val: ""
        },
        grid: {
          status: 0,
          val: ""
        },
        inverter: {
          status: 0
        },
        battery: {
          status: 0,
          val: []
        },
        consumption: {
          status: 0
        }
      }, //能量流图数据
      dialogData: {
        pv_: {
          title: this.$t("statistic.pv"),
          data: []
        }, // 光伏板
        gd_: {
          title: this.$t("statistic.gd"),
          data: []
        }, // 电网
        sy_: {
          title: this.$t("statistic.sy"),
          data: []
        }, // 逆变器
        bt_: {
          title: this.$t("statistic.bt"),
          data: []
        }, // 电池
        bc_: {
          title: this.$t("statistic.bc"),
          data: []
        } // 负载
      }, // 点击设备弹窗数据
      activeDialog: false
    };
  },
  computed: {
    ...mapGetters({
      deviceInfo: "getDeviceInfo",
      skin: "getSkin"
    }),
    activeDialogInfo() {
      if (!this.activeDialog) return null;
      return this.dialogData[this.activeDialog];
    },
    imgPath() {
      return {
        generation: require(`@/assets/img/generation_${this.skin}.png`),
        grid: require(`@/assets/img/grid_${this.skin}.png`),
        inverter: require(`@/assets/img/inverter_${this.skin}.png`),
        // battery: require(`@/assets/img/battery_${this.skin}.png`),
        consumption: require(`@/assets/img/consumption_${this.skin}.png`)
      };
    },
    batteryPath() {
      if (0 < parseFloat(this.flowData.battery.val[0]) &&  parseFloat(this.flowData.battery.val[0])<= 20) {
        return {
          battery: require(`@/assets/img/battery_1${this.skin}.png`),
          batterys:require(`@/assets/img/battery_1disable.png`)
        };
      }else if(20 < parseFloat(this.flowData.battery.val[0]) &&  parseFloat(this.flowData.battery.val[0]) <= 40){
        return {
          battery: require(`@/assets/img/battery_2${this.skin}.png`),
          batterys:require(`@/assets/img/battery_2disable.png`)
        };
      }else if(40< parseFloat(this.flowData.battery.val[0]) &&  parseFloat(this.flowData.battery.val[0]) <= 60){
        return {
          battery: require(`@/assets/img/battery_3${this.skin}.png`),
          batterys:require(`@/assets/img/battery_3disable.png`)
        };
      }else if(60 < parseFloat(this.flowData.battery.val[0]) &&  parseFloat(this.flowData.battery.val[0]) <= 80){
        return {
          battery: require(`@/assets/img/battery_4${this.skin}.png`),
          batterys:require(`@/assets/img/battery_4disable.png`)
        };
      }else if(80 < parseFloat(this.flowData.battery.val[0]) &&  parseFloat(this.flowData.battery.val[0]) <= 100){
        return {
          battery: require(`@/assets/img/battery_5${this.skin}.png`),
          batterys:require(`@/assets/img/battery_5disable.png`)
        };
      } else {
        return {
          battery: require(`@/assets/img/battery_0${this.skin}.png`),
          batterys:require(`@/assets/img/battery_0disable.png`)
        };
      }
    },
     ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
  watch: {
    deviceInfo: {
      handler() {
        this.queryData();
      },
      deep: true
    }
  },
  created() {
    this.queryData();
  },
  beforeDestroy() {
      clearInterval(this.timerEnergy);
  },
  methods: {
    // 查询页面数据
    queryData() {
      this.queryFlowData();
      this.queryDialogData();
      this.loopQuery();
    },
    loopQuery() {
      this.timerEnergy = setInterval(() => {
        this.queryFlowData();
        this.queryDialogData();     
        }, 60000);
    },
    // 查询弹窗数据
    queryDialogData() {
      let param = {
        devcode: this.deviceInfo.devcode,
        pn: this.deviceInfo.pn,
        devaddr: this.deviceInfo.devaddr,
        sn: this.deviceInfo.sn,
        i18n: this.$lang.currentLang
      };
        let url = this.isMicroService ? "/ppe/api/auth/web/querySPDeviceLastData" : "querySPDeviceLastData";
      this.$request[this.method](url, param).then(res => {
        if (res[this.code] === 0) {
          let pars = res[this.resData].pars;
          for (let key in pars) {
            if (this.dialogData[key]) {
              this.dialogData[key].data = pars[key];
            }
          }
        }
      });
    },
    // 查询能量流图数据
    queryFlowData() {
      let param = {
        devcode: this.deviceInfo.devcode,
        pn: this.deviceInfo.pn,
        devaddr: this.deviceInfo.devaddr,
        sn: this.deviceInfo.sn
      };
        let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceEnergyFlow" : "webQueryDeviceEnergyFlowEs";
        // info.Loading = true;
        this.$request[this.method](url, param).then(res => {
        if (res[this.code] === 0) {
          let data = res[this.resData];
          this.flowData = {
            generation: {
              status: data.pv_status[0].status,
              val: data.pv_status[0].unit
                ? this.$filter.formatNum(data.pv_status[0].val, 2) +
                  data.pv_status[0].unit
                : ""
            },
            grid: {
              status: data.gd_status[0].status,
              val: data.gd_status[0].unit
                ? this.$filter.formatNum(data.gd_status[0].val, 2) +
                  data.gd_status[0].unit
                : ""
            },
            inverter: {
              status: data.status,
              // label:"逆变器",
              label: this.$filter.deviceType[data.brand].label
            },
            battery: {
              status: data.bt_status[0].status,
              val: data.bt_status.reduce((result, item) => {
                item.unit &&
                  result.push(this.$filter.formatNum(item.val, 2) + item.unit);
                return result;
              }, [])
            },
            consumption: {
              status: data.bc_status[0].status,
              val: data.bc_status[0].unit
                ? this.$filter.formatNum(data.bc_status[0].val, 2) +
                  data.bc_status[0].unit
                : ""
            }
          };
        }else{
          this.flowData = {
            generation: {
              status: 0,
              val: ""
            },
            grid: {
              status: 0,
              val: ""
            },
            inverter: {
              status: 0,
              label: ""
            },
            battery: {
              status: 0,
              val: ""
            },
            consumption: {
}
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");
.flow {
  padding: 5px;
  margin-top: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #eaf0f2;
  .title {
    .sc(28px, #000);
    text-align: center;
    margin-bottom: 5px;
    height: 0px;
  }
  .scene {
    flex: 1;
    position: relative;
    .container(@horizontal, @vertical) {
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      z-index: 2;
      .image {
        font-size: 0;
        transition: transform 0.2s linear;
        position: relative;
        &::before {
          transition: all 0.2s linear;
          content: "";
          opacity: 0;
          position: absolute;
          top: -10px;
          left: -10px;
          right: -10px;
          bottom: -10px;
          border-radius: 50%;
          z-index: -1;
        }
        img {
          width: 100px;
          height: 100px;
        }
      }
      &:hover {
        .image {
          transform: translate(5px * @horizontal, 5px * @vertical);
          &::before {
            opacity: 1;
            box-shadow: -4px * @horizontal -4px * @vertical 6px 5px @borderColor;
          }
        }
      }
      .name {
        line-height: 20px;
        .sc(18px, #333);
        margin-top: 10px;
      }
    }
    .generation-container {
      .container(-1, -1);
      top: 15px;
      left: 50px;
      .image::before {
        background: linear-gradient(135deg, #fefefe, @borderColor);
      }
    }
    .grid-container {
      .container(1, -1);
      top: 15px;
      right: 50px;
      .image::before {
        background: linear-gradient(-135deg, #fefefe, @borderColor);
      }
    }
    .inverter-container {
      .container(0, -1);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -57px);
      .image::before {
        background: linear-gradient(-180deg, #fefefe, @borderColor);
      }
    }
    .battery-container {
      .container(-1, 1);
      bottom: 15px;
      left: 50px;
      .image::before {
        background: linear-gradient(45deg, #fefefe, @borderColor);
      }
    }
    .consumption-container {
      .container(1, 1);
      bottom: 15px;
      right: 50px;
      .image::before {
        background: linear-gradient(-45deg, #fefefe, @borderColor);
      }
    }
    .value(@positive, @position) {
      position: absolute;
      &:not(.enable) {
        background: repeating-linear-gradient(
          45deg * @positive,
          #d7d7d7 0,
          #d7d7d7 30%,
          #eaf0f2 30%,
          #eaf0f2 50%
        );
        background-size: 30px 30px;
      }
      &.enable {
        background: repeating-linear-gradient(
          45deg * @positive,
          @themeColor 0,
          @themeColor 30%,
          #eaf0f2 30%,
          #eaf0f2 50%
        );
        background-size: 30px 30px;
        .data {
          color: @themeColor;
        }
      }
      &.positive {
        @keyframes positive {
          100% {
            background-position: -100%;
          }
        }
        animation: positive 18s linear infinite;
      }
      &.negative {
        @keyframes negative {
          100% {
            background-position: 100%;
          }
        }
        animation: negative 18s linear infinite;
      }
      .data {
        height: 100%;
        // background: #fff;
        background: #eaf0f2;
        display: grid;
        justify-content: center;
        justify-items: center;
        align-items: @position;
        // padding: 10px;
        font-size: 32px;
        color: #d7d7d7;
      }
    }
    .value-generation {
      .value(-1, flex-end);
      top: 150px;
      right: calc(~"50% + 60px");
      bottom: calc(~"50% + 20px");
      left: 100px;
      border-bottom-left-radius: 10px;
      padding: 0 0 5px 5px;
      .data {
        border-bottom-left-radius: 10px;
      }
    }
    .value-grid {
      .value(1, flex-end);
      top: 150px;
      right: 100px;
      bottom: calc(~"50% + 20px");
      left: calc(~"50% + 60px");
      border-bottom-right-radius: 10px;
      padding: 0 5px 5px 0;
      .data {
        border-bottom-right-radius: 10px;
      }
    }
    .value-battery {
      margin-top: 15px;
      .value(1, flex-start);
      top: calc(~"50% + 20px");
      right: calc(~"50% + 60px");
      bottom: 150px;
      left: 100px;
      border-top-left-radius: 10px;
      padding: 5px 0 0 5px;
      .data {
        border-top-left-radius: 10px;
      }
    }
    .value-consumption {
      margin-top: 15px;
      .value(-1, flex-start);
      top: calc(~"50% + 20px");
      right: 100px;
      bottom: 150px;
      left: calc(~"50% + 60px");
      border-top-right-radius: 10px;
      padding: 5px 5px 0 0;
      .data {
        border-top-right-radius: 10px;
      }
    }
  }
}
.dialog {
  .list {
    display: grid;
    grid-template-columns: auto auto auto auto;
    .sc(14px, #333);
    border: 1px solid @borderColor;

    .item {
      line-height: 40px;
      padding: 0 30px;
      &:nth-child(8n + 5),
      &:nth-child(8n + 6),
      &:nth-child(8n + 7),
      &:nth-child(8n + 8) {
        background: #ecf1f4;
      }
    }
  }
}
</style>